const template = `
  <div class="uoe-container">
    <div class="uoe-content">
      <h2 id="uoe-consent-desc" class="uoe-heading">Error with EdGEL Cookie Consent settings</h2>
      <ul class="uoe-list">
      </ul>
      <button type="button" class="uoe-btn uoe-btn-secondary" data-consent-close>Close</button>
    </div>
  </div>
`

export default template
